export function isLate (dateStr) {
  if (dateStr === '' || dateStr === null || dateStr === undefined) return false
  const [dateWithNoHour, _] = dateStr.split(' ').map(String)
  const [day, month, year] = dateWithNoHour.split('/').map(Number)
  const inputDate = new Date(year, month - 1, day)
  const today = new Date()

  inputDate.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)

  return inputDate < today
}

export function calculateLateDays (dateStr) {
  if (dateStr === '' || dateStr === null || dateStr === undefined) return 0
  const [dia, mes, ano] = dateStr.split('/').map(Number)
  const dataInformada = new Date(ano, mes - 1, dia)
  dataInformada.setHours(0, 0, 0, 0)
  const hoje = new Date()
  hoje.setHours(0, 0, 0, 0)
  const diffEmMs = dataInformada - hoje
  const diffEmDias = Math.floor(diffEmMs / (1000 * 60 * 60 * 24))
  return diffEmDias > 0 ? diffEmDias : 0
}
